var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSignalCentralStation01({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Warstwa_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 16 16",
    style: {
      enableBackground: "new 0 0 16 16"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#1E1E1C;}\n\t.st1{fill:#FFFFFF;}\n\t.st2{fill:#FFFFFF;}\n\t.st3{enable-background:new    ;}\n\t.st4{fill:none;stroke:#FFFFFF;stroke-width:0.5;stroke-miterlimit:10;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M14.38,11.87H1.62V4.13h12.75V11.87z M2.12,11.37h11.75V4.63H2.12V11.37z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 3.46,
    y: 4.38,
    className: "st2",
    width: 0.5,
    height: 7.23
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 12.09,
    y: 4.38,
    className: "st2",
    width: 0.5,
    height: 7.23
  })), /*#__PURE__*/React.createElement("g", {
    className: "st3"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M5.27,9.3C5.48,9.43,5.8,9.54,6.14,9.54c0.5,0,0.79-0.26,0.79-0.64c0-0.35-0.2-0.55-0.71-0.75 c-0.62-0.22-1-0.54-1-1.07c0-0.59,0.49-1.02,1.22-1.02c0.39,0,0.67,0.09,0.83,0.18l-0.13,0.4C7.02,6.57,6.77,6.46,6.42,6.46 c-0.52,0-0.71,0.31-0.71,0.57c0,0.35,0.23,0.53,0.75,0.73C7.1,8,7.43,8.31,7.43,8.86c0,0.58-0.43,1.09-1.32,1.09 c-0.36,0-0.76-0.11-0.96-0.24L5.27,9.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M10.73,9.77c-0.18,0.09-0.54,0.18-1,0.18c-1.06,0-1.87-0.67-1.87-1.91c0-1.18,0.8-1.98,1.97-1.98 c0.47,0,0.77,0.1,0.9,0.17l-0.12,0.4c-0.18-0.09-0.45-0.16-0.76-0.16c-0.88,0-1.47,0.57-1.47,1.56c0,0.92,0.53,1.52,1.45,1.52 c0.3,0,0.6-0.06,0.79-0.16L10.73,9.77z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignalCentralStation01);
export default __webpack_public_path__ + "static/media/SignalCentralStation-01.856dc26080555d552ccaec0609cb3b0d.svg";
export { ForwardRef as ReactComponent };